import { Api } from 'utils';

class SurveysService {
  static get = async (params = {}) =>
    Api.createResponse('app/surveys/', params);
}

export default SurveysService;
